import React from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItemType } from '../../../models/api/codegen/code';
import { NavLink, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { SELECT_SPORT_MENU } from '../../../store/spirs/actions';

export interface NavigationTabsProps {
    desktopTabRoutes: string[];
    menu: TabMenu[];
    onSearchToggle?: () => void;
}

export type TabMenu = {
    state?: string;
    route: string;
    label: string;
    counter: string;
    flag: boolean;
    icon?: React.ReactElement;
    type: MenuItemType['type'];
    isMobile: boolean;
};

export const NavigationTabs: React.FC<NavigationTabsProps> = ({
    desktopTabRoutes,
    menu,
    onSearchToggle
}) => {
    const location = useLocation();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const selectedTab = desktopTabRoutes.includes(location.pathname)
        ? location.pathname
        : false;

    const handleTabClick = () => {
        dispatch(SELECT_SPORT_MENU(-1)); // Сбрасываем выбранный спорт
    };

    return (
        <div className="flex items-center max-tablet:justify-between tablet:gap-[20px]">
            {menu.map((el, i) => (
                <div
                    key={i}
                    className={`${
                        !el.isMobile ? 'max-tablet:hidden' : ''
                    } grid grid-rows-[auto_3px]`}
                >
                    <NavLink
                        to={el.route}
                        onClick={handleTabClick}
                        className="flex items-center px-[10px] tablet:uppercase text-[12px] tablet:text-[14px] desktop:text-[16px] text-[#C6C7C9] font-medium py-[4px] tablet:py-[17px]"
                    >
                        {el.icon && el.icon}
                        <span
                            className={
                                el.state === 'favorites'
                                    ? 'max-notebook:hidden'
                                    : ''
                            }
                        >
                            {t(el.label) + el.counter}
                        </span>
                    </NavLink>
                    {selectedTab === el.route && (
                        <div className="bg-[#D32F2F]" />
                    )}
                </div>
            ))}
        </div>
    );
};
